import type { RouteRecordRaw } from "vue-router";
const onError = (err: any) => {
  console.error("Failed to load async component: ", err);
  throw new Error(err);
};

const UpdownStream: RouteRecordRaw = {
  name: "上下游对接",
  path: "/updown-stream",
  component: () => import("@/components/Layout/index.vue").catch(onError),
  redirect: "/updown-stream/appsflyer-package",
  meta: {
    key: "/updown-stream"
  },
  children: [
    {
      name: "三方产品查询",
      path: "appsflyer-package",
      meta: {
        key: "/updown-stream/appsflyer-package"
      },
      component: () =>
        import("@/views/UpdownStream/AFPackageList/index.vue").catch(onError)
    },
    {
      name: "三方内部授权",
      path: "apply-permission",
      meta: {
        key: "/updown-stream/apply-permission"
      },
      component: () =>
        import("@/views/UpdownStream/ApplyPermission/index.vue").catch(onError)
    },
    {
      name: "预付额度管理",
      path: "amount",
      meta: {
        key: "/updown-stream/amount"
      },
      component: () =>
        import("@/views/UpdownStream/Amount/index.vue").catch(onError)
    },
    {
      name: "预付额度初始化",
      path: "amount-init",
      meta: {
        key: "/updown-stream/amount-init"
      },
      component: () =>
        import("@/views/UpdownStream/AmountInit/index.vue").catch(onError)
    },
    {
      name: "广告主 / 渠道交接",
      path: "handover",
      meta: {
        key: "/updown-stream/handover"
      },
      component: () =>
        import("@/views/UpdownStream/Handover/index.vue").catch(onError)
    },
    {
      name: "渠道侧Postback对接",
      path: "postback-test",
      meta: {
        key: "/updown-stream/postback-test"
      },
      component: () =>
        import("@/views/UpdownStream/PostbackTest/index.vue").catch(onError)
    },
    {
      name: "广告主原始单子",
      path: "order",
      meta: {
        key: "/updown-stream/order"
      },
      component: () =>
        import("@/views/UpdownStream/Order/index.vue").catch(onError)
    },
    {
      name: "广告主原始订单创建",
      path: "order-create",
      meta: {
        key: "/updown-stream/order-create"
      },
      component: () =>
        import("@/views/UpdownStream/Order/components/OrderCreate.vue").catch(
          onError
        )
    },
    {
      name: "广告主原始订单编辑",
      path: "order-edit",
      meta: {
        key: "/updown-stream/order-edit"
      },
      component: () =>
        import("@/views/UpdownStream/Order/components/OrderEdit.vue").catch(
          onError
        )
    },
    {
      name: "广告主原始订单详情",
      path: "order-detail",
      meta: {
        key: "/updown-stream/order-detail"
      },
      component: () =>
        import("@/views/UpdownStream/Order/components/OrderDetail.vue").catch(
          onError
        )
    }
  ]
};

export default UpdownStream;
